/** Why MeetNPlan copy in Arabic. Mirrors `../../en/home/why.js` key for key. */
import whyArabic from '@/assets/images/why/arabic-first.webp'
import whyClientInvites from '@/assets/images/why/client-invites.webp'
import whyEmailInvites from '@/assets/images/why/email-invites.webp'
import whyCalendar from '@/assets/images/why/google-calendar.webp'
import whyMessaging from '@/assets/images/why/messaging.webp'
import whyRooms from '@/assets/images/why/rooms.webp'
import whyVideo from '@/assets/images/why/video-meetings.webp'
import whyVisitors from '@/assets/images/why/visitors.webp'

export const WHY = {
  eyebrow: 'لماذا MeetNPlan',
  title: 'صُمّم ليناسب طريقة عمل\nالمكاتب هنا',
  text: 'واجهة عربية كاملة من اليمين إلى اليسار، وتنسيقات التاريخ السعودية، وتسجيل دخول الزوار بالتوقيع، وموافقات تمر عبر الموارد البشرية قبل تأكيد القاعة. ويتكامل مع التقويمات التي يستخدمها فريقك بالفعل.',
  items: [
    {
      image: whyArabic,
      accent: 'blue',
      tag: 'اللغة',
      title: 'العربية أولًا',
      text: 'واجهة كاملة من اليمين إلى اليسار ونصوص عربية، مع الإنجليزية بنقرة واحدة.',
    },
    {
      image: whyCalendar,
      accent: 'red',
      tag: 'التكاملات',
      title: 'تقويم Google',
      text: 'تتزامن الاجتماعات مع التقويم الذي يستخدمه فريقك بالفعل.',
    },
    {
      image: whyVisitors,
      accent: 'teal',
      tag: 'الاستقبال',
      title: 'إدارة الزوار',
      text: 'تسجيل الدخول والتوقيعات وتنبيهات المضيفين، حتى لا ينتظر الضيوف أبدًا.',
    },
    {
      image: whyMessaging,
      accent: 'violet',
      tag: 'المراسلة',
      title: 'المراسلة الداخلية',
      text: 'محادثات مباشرة وجماعية ومحادثات للاجتماعات، مع إشعارات القراءة والردود ومشاركة الملفات.',
    },
    {
      image: whyEmailInvites,
      accent: 'blue',
      tag: 'الدعوات',
      title: 'دعوات البريد بنقرة واحدة',
      text: 'أرسل دعوات الاجتماعات عبر البريد بنقرة واحدة، مع تتبّع ردود كل مدعو.',
    },
    {
      image: whyClientInvites,
      accent: 'orange',
      tag: 'الضيوف',
      title: 'دعوة العملاء',
      text: 'ادعُ أشخاصًا من خارج الشركة، ويُميَّزون كضيوف خارجيين.',
    },
    {
      image: whyRooms,
      accent: 'green',
      tag: 'القاعات',
      title: 'إدارة القاعات',
      text: 'أعدّ القاعات بسعتها وتجهيزاتها، واعرف المتاح منها الآن.',
    },
    {
      image: whyVideo,
      accent: 'teal',
      tag: 'الفيديو',
      title: 'الاجتماعات عبر الإنترنت والفيديو',
      text: 'أضف رابط فيديو لأي اجتماع، أو اجتمع في قاعة وعبر الإنترنت في الوقت نفسه.',
    },
  ],
}
